/*eslint-disable */
import React, { useState, useEffect } from 'react'
import { Button, Modal, Dropdown, Icon } from 'semantic-ui-react'
import { DateData } from "../dynamicComponent/datepick";
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import { connect } from "react-redux";
import { AllRegex } from "../../utils/validation";
import UpdateAxios from '../axiosComponent/update';
import CreatAxios from '../axiosComponent/create';
import UploadFile from '../common/uploadFile';
import moment from 'moment';
import {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from 'react-i18next';
import ReadAxios from '../axiosComponent/read';
import { LOCAL_STORAGE, DATE_FORMATS } from '../../utils/constant';
import Axios from 'axios';
import MyVehicleOwnership from '../apiInputs/myVehicleOwnerShip';
const VendorVehicleEdit = ({ isSubmitting, handleSubmit, setFieldValue, values, touched, errors, t, vehicleModal, CloseModal, editUserMode }) => {

    useEffect(() => {
     getTrackingTypes()
    }, []);
    const [trackingTypes, setTrackingTypes] = useState([])

    const getTrackingTypes = ()=>{
        ReadAxios({ url: 'trackingTypeMaster/' })
        .then(async (result) => {
            let Options = []
            result?.data?.resultSet.map((object, index) => {
                let temp = {}
                temp.key = object.trackingTypeId
                temp.text = object.trackingType
                temp.value = object.trackingTypeId
                return Options[index] = temp
            })
            setTrackingTypes(Options)
            await Axios.get(`${process.env.REACT_APP_MASTER_API}/customerSettings?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }).then((resp)=>{
                if(resp.data.status===200){
                   resp?.data?.resultSet?.preferredTrackingType? setFieldValue("trackingTypeId",resp.data.resultSet.preferredTrackingType) : setFieldValue("trackingTypeId",1)
                }else{
                    setFieldValue("trackingTypeId",1)
                }
            })
            
        }).catch((err)=>{
            console.log(err);
        })
    }

    return (
        <Modal
            onClose={CloseModal}
            open={vehicleModal}
            size="large"
            className="p-overflow-initial"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{editUserMode ? t('edit_title') : t('add')} {t("title")}</Modal.Header>
            <Modal.Content>
                <div className="ui form small">
                    <FormUi.Group inline={errors.vehicleNumber || errors.vehicleType ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_no")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleNumber ? false : true} width="4">
                            <Fieldmik name="vehicleNumber" component={MyNormalInput} />
                            {touched.vehicleNumber && errors.vehicleNumber ? <small className="text-danger">{errors.userName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_type")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleType ? false : true} width="4">
                            {/* <Fieldmik name="vehicleType" component={MyNormalInput} /> */}
                            <SearchDropdown
                            key={values.vehicleType}
                            setField={(name, data) => {
                                setFieldValue("vehicleTypeId", data.key);
                                setFieldValue("vehicleType", data.title);
                            }}
                            masterRoute="vehicleTypeMaster"
                            masterRouteKey="vehicleTypeId"
                            masterRouteName="vehicleType"
                            fieldName="vehicleType"
                            deafultValue={values.vehicleType}
                        />
                            {touched.vehicleType && errors.vehicleType ? <small className="text-danger">{errors.vehicleType}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.vehicleCapacity || errors.vehicleOwner ? false : true}>
                        {/* <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_dimension")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleDimension ? false : true} width="4">
                            <Fieldmik name="vehicleDimension" component={MyNormalInput} />
                            {touched.vehicleDimension && errors.vehicleDimension ? <small className="text-danger">{errors.vehicleDimension}</small> : ''}
                        </FormUi.Field> */}
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_ownership")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleOwner ? false : true} width="4">
                        <Fieldmik name="vehicleOwner" component={MyVehicleOwnership} placeholder={"Select Type"} value={values.vehicleOwner} nameValue={true}/>
                        {touched.vehicleOwner && errors.vehicleOwner ? <small className="text-danger">{errors.vehicleOwner}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.tracking_type")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.trackingTypeId ? false : true} width="4">
                        <Dropdown
                            name="trackingTypeId"
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            selection
                            placeholder={
                                t("placeholders.tracking_type")||"Select Tracking Type"
                            }
                            onChange={(name, data) => setFieldValue("trackingTypeId", data.value)}
                            options={trackingTypes}
                            value={values.trackingTypeId}
                            />
                            {touched.trackingTypeId && errors.trackingTypeId ? <small className="text-danger">{errors.trackingTypeId}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.vehicleBaseLocation || errors.vehicleGps ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.gps_vendor")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleGps ? false : true} width="4">
                            <Fieldmik maxLength="10" name="vehicleGps" type="text" component={MyNormalInput} />
                            {touched.vehicleGps && errors.vehicleGps ? <small className="text-danger">{errors.vehicleGps}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.base_location")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleBaseLocation ? false : true} width="4">
                            <Fieldmik maxLength="10" name="vehicleBaseLocation" type="text" component={MyNormalInput} />
                            {touched.vehicleBaseLocation && errors.vehicleBaseLocation ? <small className="text-danger">{errors.vehicleBaseLocation}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.vehicleDimensions ? false : true}>
                            <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_dimension")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleDimensions ? false : true} width="4">
                            <Fieldmik name="vehicleDimensions" placeholder="L* B *H" component={MyNormalInput} />
                            {touched.vehicleDimensions && errors.vehicleDimensions ? <small className="text-danger">{errors.vehicleDimensions}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_load_capacity")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleCapacity ? false : true} width="4">
                            <Fieldmik name="vehicleCapacity" component={MyNormalInput} />
                            {touched.vehicleCapacity && errors.vehicleCapacity ? <small className="text-danger">{errors.vehicleCapacity}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.vehiclePUCExpiryDate ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.puc")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehiclePUCExpiryDate ? false : true} width="4">
                        <DateData
                            name="vehiclePUCExpiryDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyyy||"dd/MM/yyyy"}
                            timeIntervals={5}
                            customInput={
                                <FormUi.Input
                                icon="time"
                                className="dateWidth"
                                iconPosition="left"
                                />
                            }
                        />
                        {/* <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehiclePermitFile ? <> PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehiclePUCFile" /> */}
                            {touched.vehiclePUCExpiryDate && errors.vehiclePUCExpiryDate ? <small className="text-danger">{errors.vehiclePUCExpiryDate}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.insurance")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleInsuranceExpiryDate ? false : true} width="4">
                        <DateData
                            name="vehicleInsuranceExpiryDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyyy||"dd/MM/yyyy"}
                            timeIntervals={5}
                            customInput={
                                <FormUi.Input
                                icon="time"
                                className="dateWidth"
                                iconPosition="left"
                                />
                            }
                        />
                        {/* <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehiclePermitFile ? <> PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehicleInsuranceFile" /> */}
                            {touched.vehicleInsuranceExpiryDate && errors.vehicleInsuranceExpiryDate ? <small className="text-danger">{errors.vehicleInsuranceExpiryDate}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.vehicleFitnessCertExpiryDate ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.fitness_certificate")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleFitnessCertExpiryDate ? false : true} width="4">
                        <DateData
                            name="vehicleFitnessCertExpiryDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyyy||"dd/MM/yyyy"}
                            timeIntervals={5}
                            customInput={
                                <FormUi.Input
                                icon="time"
                                className="dateWidth"
                                iconPosition="left"
                                />
                            }
                        />
                        {/* <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehiclePermitFile ? <> PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehicleFitnessCertFile" /> */}
                            {touched.vehicleFitnessCertExpiryDate && errors.vehicleFitnessCertExpiryDate ? <small className="text-danger">{errors.vehicleFitnessCertExpiryDate}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.permit")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehiclePermitExpiryDate ? false : true} width="4">
                        <DateData
                            name="vehiclePermitExpiryDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyyy||"dd/MM/yyyy"}
                            timeIntervals={5}
                            customInput={
                                <FormUi.Input
                                icon="time"
                                className="dateWidth"
                                iconPosition="left"
                                />
                            }
                        />
                        {/* <Fieldmik component={UploadFile} typer={[".pdf"]} clrd="blue" buttonName={values.vehiclePermitFile ? <> PDF <Icon color="green" name="check" /> </> : 'PDF'} name="vehiclePermitFile" /> */}
                            {touched.vehiclePermitExpiryDate && errors.vehiclePermitExpiryDate ? <small className="text-danger">{errors.vehiclePermitExpiryDate}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.vehicleRCNoExpiryDate ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.vehicle_rc")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleRCNoExpiryDate ? false : true} width="4">
                        <Fieldmik name="vehicleRCNo"  component={MyNormalInput} />
                        <DateData
                            name="vehicleRCNoExpiryDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyyy||"dd/MM/yyyy"}
                            timeIntervals={5}
                            customInput={
                                <FormUi.Input
                                icon="time"
                                className="dateWidth"
                                iconPosition="left"
                                />
                            }
                        />
                            {touched.vehicleRCNoExpiryDate && errors.vehicleRCNoExpiryDate ? <small className="text-danger">{errors.vehicleRCNoExpiryDate}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.road_tax")}</label>
                        </FormUi.Field>
                        <FormUi.Field error={values.vehicleRoadTaxValidityDate ? false : true} width="4">
                        <DateData
                            name="vehicleRoadTaxValidityDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyyy||"dd/MM/yyyy"}
                            timeIntervals={5}
                            customInput={
                                <FormUi.Input
                                icon="time"
                                className="dateWidth"
                                iconPosition="left"
                                />
                            }
                        />
                            {touched.vehicleRoadTaxValidityDate && errors.vehicleRoadTaxValidityDate ? <small className="text-danger">{errors.vehicleRoadTaxValidityDate}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {t("cancel")}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {t("ok")}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}
const FormikUserEdit = withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props, vehicleNumber, vehicleOwner, vehicleType, vehicleTypeId, vehicleDimensions,
        vehicleBaseLocation, vehicleCapacity, vehicleGps, vehiclePUCExpiryDate, vehicleInsuranceExpiryDate,
        vehicleFitnessCertExpiryDate, vehiclePermitExpiryDate, vehicleRCNo, vehicleRCNoExpiryDate, vehicleRoadTaxValidityDate,trackingTypeId) => {
        // console.log(">>>", props.id)
        return {
            vehicleNumber: (props.editData ? props.editData.vehicleNumber : vehicleNumber) || '',
            vehicleOwner: (props.editData ? props.editData.vehicleOwner : vehicleOwner) || '',
            vehicleType: (props.editData ? props.editData.vehicleType : vehicleType) || '',
            vehicleTypeId: (props.editData ? props.editData.vehicleTypeId : vehicleTypeId) || '',
            vehicleDimensions: (props.editData ? props.editData.vehicleDimensions : vehicleDimensions) || '',
            vehicleBaseLocation: (props.editData ? props.editData.vehicleBaseLocation : vehicleBaseLocation) || '',
            vehicleCapacity: (props.editData ? props.editData.vehicleCapacity : vehicleCapacity) || '',
            vehicleGps: (props.editData ? props.editData.vehicleGps : vehicleGps) || '',
            vehiclePUCExpiryDate: (props.editData ? props.editData.vehiclePUCExpiryDate : vehiclePUCExpiryDate) || '',
            vehicleInsuranceExpiryDate: (props.editData ? props.editData.vehicleInsuranceExpiryDate : vehicleInsuranceExpiryDate) || '',
            vehicleFitnessCertExpiryDate: (props.editData ? props.editData.vehicleFitnessCertExpiryDate : vehicleFitnessCertExpiryDate) || '',
            vehiclePermitExpiryDate: (props.editData ? props.editData.vehiclePermitExpiryDate : vehiclePermitExpiryDate) || '',
            vehicleRCNo: (props.editData ? props.editData.vehicleRCNo : vehicleRCNo) || '', 
            vehicleRCNoExpiryDate: (props.editData ? props.editData.vehicleRCNoExpiryDate : vehicleRCNoExpiryDate) || '',
            vehicleRoadTaxValidityDate: (props.editData ? props.editData.vehicleRoadTaxValidityDate : vehicleRoadTaxValidityDate) || '',
            trackingTypeId : (props.editData ? props.editData.trackingTypeId : trackingTypeId) || '',


            // consigneeId: (props.editParams ? props.editParams.email : email) || '',
            // vendorId: (props.editUserMode ? '' : props.productName == 'vendor' ? (props.editParams ? props.editParams.u_id : '') : props.id) || '',
            transporterId: (props.vendorId ? props.vendorId : props.vendorId) || '',
        }
    },
    // validationSchema: yup.object({
    //     userName: yup.string().required("required"),
    //     realName: yup.string().required("required"),
    //     email: yup.string().email('Invalid Email').required("required"),
    //     mobileNo: yup.string().matches(AllRegex.MobileNumber, 'Invalid Mobile Number').required("required"),
    // }),
    async handleSubmit(values, { props }) {
        let puc = values.vehiclePUCFile ? values.vehiclePUCFile.base64.split(',') : null
    let insurance = values.vehicleInsuranceFile ? values.vehicleInsuranceFile.base64.split(',') : null
    let fitness = values.vehicleFitnessCertFile ? values.vehicleFitnessCertFile.base64.split(',') : null
    let permit = values.vehiclePermitFile ? values.vehiclePermitFile.base64.split(',') : null
    let vehiclePUCFile = puc ? puc[1] : null
    let vehicleInsuranceFile = insurance ? insurance[1] : null
    let vehicleFitnessCertFile = fitness ? fitness[1] : null
    let vehiclePermitFile = permit ? permit[1] : null
    let vehiclePUCExpiryDate = values.vehiclePUCExpiryDate instanceof Date && !isNaN(values.vehiclePUCExpiryDate) ? moment(values.vehiclePUCExpiryDate).format(DATE_FORMATS?.DATE_YYYYMMDD) : ""
    let vehicleInsuranceExpiryDate = values.vehicleInsuranceExpiryDate instanceof Date && !isNaN(values.vehicleInsuranceExpiryDate) ?  moment(values.vehicleInsuranceExpiryDate).format(DATE_FORMATS?.DATE_YYYYMMDD) :""
    let vehiclePermitExpiryDate = values.vehiclePermitExpiryDate instanceof Date && !isNaN(values.vehiclePermitExpiryDate) ?  moment(values.vehiclePermitExpiryDate).format(DATE_FORMATS?.DATE_YYYYMMDD) :""
    let vehicleFitnessCertExpiryDate = values.vehicleFitnessCertExpiryDate instanceof Date && !isNaN(values.vehicleFitnessCertExpiryDate) ?  moment(values.vehicleFitnessCertExpiryDate).format(DATE_FORMATS?.DATE_YYYYMMDD) :""
    let vehicleRCNoExpiryDate = values.vehicleRCNoExpiryDate instanceof Date && !isNaN(values.vehicleRCNoExpiryDate) ?  moment(values.vehicleRCNoExpiryDate).format(DATE_FORMATS?.DATE_YYYYMMDD) :""
    let vehicleRoadTaxValidityDate = values.vehicleRoadTaxValidityDate instanceof Date && !isNaN(values.vehicleRoadTaxValidityDate) ?  moment(values.vehicleRoadTaxValidityDate).format(DATE_FORMATS?.DATE_YYYYMMDD) :""
        console.log('values',values)
        // return
        if (props.editData && props.vendorId) {
            await UpdateAxios({
                url: `vehicleMaster/${props.productName}`,
                payload: { ...values,vehiclePUCFile,
                    vehicleInsuranceFile,
                    vehicleFitnessCertFile,
                    vehiclePermitFile,
                    vehiclePUCExpiryDate,
                    vehiclePermitExpiryDate,
                    vehicleFitnessCertExpiryDate,
                    vehicleRCNoExpiryDate,
                    vehicleRoadTaxValidityDate,
                    vehicleInsuranceExpiryDate },
                uniqueId: props.vendorId,
            }).then((response) => {
                let alert = {
                    type: "success",
                    messageHeader: "Success",
                    messageBody: `Vehicle is updated.`,
                };
                props.CloseModal(true)
                window.location.reload()
                props.successAlertDispatcher(alert);
                props.onFormSubmit();
            })
                .catch((err) => {
                    if (err.data.status === 204) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: `${err.data.message} `,
                        };
                        props.errorAlertDispatcher(alert);
                    }
                });
        } else {
            await CreatAxios({
                url: `vehicleMaster/`,
                payload: { ...values,
                    vehiclePUCFile,
                    vehicleInsuranceFile,
                    vehicleFitnessCertFile,
                    vehiclePermitFile,
                    vehiclePUCExpiryDate,
                    vehiclePermitExpiryDate,
                    vehicleFitnessCertExpiryDate,
                    vehicleRCNoExpiryDate,
                    vehicleRoadTaxValidityDate,
                    vehicleInsuranceExpiryDate },
            })
                .then((res) => {
                    let alert = {
                        type: "success",
                        messageHeader: "Success",
                        messageBody: `Vehicle is created.`,
                    };
                    props.CloseModal(true)
                    window.location.reload()
                    props.successAlertDispatcher(alert);
                    props.onFormSubmit();
                })
                .catch((err) => {
                    if (err.data.status === 204) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: `${err.data.message}`,
                        };
                        props.errorAlertDispatcher(alert);
                    }

                });
        }
    }

})(VendorVehicleEdit)
export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(translate('vehicle')(FormikUserEdit))
